export default function initContactHeader(): void {
    const $contactHeaderContainer = document.querySelectorAll<HTMLElement>('.contact-header');

    $contactHeaderContainer.forEach($container => {
        new ContactHeaderContainer($container);
    });
}

class ContactHeaderContainer {
    $el: HTMLElement | null | undefined;
    $btn: HTMLElement | null | undefined;
    $push: HTMLElement | null | undefined;
    $form: HTMLElement | null | undefined;

    constructor($el: HTMLElement | null) {
        this.$el = $el;
        this.$btn = $el?.querySelector('.btn-active-contact-form');
        this.$push = $el?.querySelector('.wrapper-contact-push');
        this.$form = $el?.querySelector('.wrapper-contact-form');
        this.init();
    }

    init() {
        this.$btn?.addEventListener('click', () => {
            this.$btn?.classList.add('hidden');
            this.$push?.classList.add('hidden');
            this.$form?.classList.add('visible');
        })
    }
}
